import { useStore } from '../../StateProvider'
import styles from '../Message/style.css'
import React from 'react'
import { Clock, Fail, Mail, Success } from './Icons'

/**
 * @param {Kind} type
 */
const getIcon = (type) => {
  switch (type) {
    case 'clock':
      return <Clock />
    case 'mail':
      return <Mail />
    case 'success':
      return <Success />
    case 'failed':
      return <Fail />
    default:
      return null
  }
}

/**
 * @param {{ kind: Kind }} props
 */
const ThemedIcon = ({ kind }) => {
  const [
    {
      whitelabel: { theme = 'default' }
    }
  ] = useStore()
  const icon = getIcon(kind)

  return icon ? (
    <span className={styles.icon} data-theme={theme} data-kind={kind}>
      {icon}
    </span>
  ) : null
}

export { ThemedIcon }
